type TLocalConfig = {
  apiUrl: string;
};

export const getConfig = (): TLocalConfig => {
  // локальная разработка
  if (import.meta.env.MODE === 'development') {
    return { apiUrl: '' };
  }

  switch (import.meta.env.VITE_APP_ENV) {
    case 'prod':
      return {
        apiUrl: 'https://api.letsgochat.ru',
      };
    case 'dev':
      return {
        apiUrl: 'https://api.dev.letsgochat.ru',
      };
    default:
      return {
        apiUrl: import.meta.env.VITE_API_URL,
      };
  }
};

export const getApiUrl = (): TLocalConfig => {
  const configData = getConfig();
  return configData;
};
